import { render, staticRenderFns } from "./ManageAvatarCategoryModal.vue?vue&type=template&id=4241c378&"
import script from "./ManageAvatarCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ManageAvatarCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports